
import { DialogContent, DialogTitle, IconButton, withStyles } from '@material-ui/core';
// @ts-ignore
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
    WithStyles,
    Typography,
    Grid,
    Button,
    Dialog,
} from '@material-ui/core';
import cx from "classnames";
import styles from './RemedialQuestionStyles';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
    NavigateBeforeOutlined as BackIcon,
} from "@material-ui/icons";
import { MyPATExpansionPanel, MyPATMultiSearch } from '../../../../common';
import CustomInfoIcon from '../../../../common/CustomInfoIcon';
import { ADD_COMMON_QSTN, ADD_QUESTION, CHOOSE_FROM_LIBRARY, ERROR, ERROR_MESSAGE_CONTENT_ID, OR, REMEDIAL_QUESTION, SEARCH, SEARHC_QUESTION_ID, SUCCESS } from './stringConstant';
import ContentData from '../../../types/ContentData';
import DeletePopUp from '../wrapperComponent/popUps';
import { CONTENT_LIST_LIMIT, FilterValues, InitialState, PAGE_CONTENT_TYPE, PROPS_REMEDIAL_KEY, PageKeys, QUESTION_LIMIT, REMEDIAL_PAGE_KEY } from './RemedialQuestionConstants';
import { CONTENT_SECTION_KEYS, CONTENT_SECTION_TYPES, CONTENT_STATES, QUESTION_TYPES } from '../../../../../constants/comman';
import contentService from '../../../services/contentService';
import { showMsg } from '../../../../course/actions/loaderAlert';
import { DEFAULT_PAGE_STATE, REMEDIAL_KEY, initialQuestionState, remedialQuestionActions } from '../../../reducers/remedialQuestionReducer';
import { formatRemedialQuestionApi, getNumberFromString, getPageNumber } from './utils';
import WithContent from "../../../containers/WithContent";
import { isQuestionTypeAllowed } from '../../../helper/questionTab';
import contentActions from '../../../actions/contentActions';
import { questionActions } from '../../../reducers/questionCreateReducer';
import RemedialSelectedIndivualComponent from './RemedialSelectedIndivualComponent'
import { getPropertyValue } from '../../../../../utils';


interface RemedialQuestionProps extends WithStyles<typeof styles> {
    defaultExpanded: boolean;
    showMsg: Function,
    remedialQuestionSliceState: any,
    addRemedialQuestionInSliceState: Function,
    addRemedialQuestionIdsInQuestionCreateSliceState: Function,
    remedialQuestionIds: any,
    clearContentListData: Function,
    QuestionId: string,
    fromParagraph: boolean,
    remdialSelectedQuestionNo: number,
    remedialKey: string,
    QuestionTypeCode: number,
    addCommonRemedialQuestion?: boolean,
    handleAddCommonRemedialQuestion?: Function,
    setRemedialSliceUpdated: Function,
    isRemedialSliceUpdatedMap: any,
}

interface RemedialQuestionState {
    suggestedQuestions: any[];
    existingQuestions: any[];
    deletePopUpDialog: boolean;
    deletePopUpDialogForPage: boolean,
    deleteKeyForPage: boolean,
    chooseLibraryKey: string,
}

const RemedialQuestion = (props: RemedialQuestionProps) => {
    const {
        defaultExpanded = true,
        classes,
        showMsg,
        addRemedialQuestionInSliceState,
        addRemedialQuestionIdsInQuestionCreateSliceState,
        remedialQuestionIds,
        remedialQuestionSliceState,
        clearContentListData,
        QuestionId,
        remedialKey,
        QuestionTypeCode,
        addCommonRemedialQuestion = false,
        handleAddCommonRemedialQuestion,
        isRemedialSliceUpdatedMap,
        setRemedialSliceUpdated
    } = props;

    const [suggestedQuestions, setSuggestedQuestions] = useState<RemedialQuestionState>([]);
    const [existingQuestions, setExisitingQuestions] = useState<RemedialQuestionState>([]);
    const [deletePopUpDialog, setDeletePopUpDialog] = useState<RemedialQuestionState>(false);
    const [deletePopUpDialogForPage, setDeletePopUpDialogForPage] = useState<RemedialQuestionState>(false);
    const [deleteKeyForPage, setDeleteKeyForPage] = useState<RemedialQuestionState>(InitialState.EMPTY_STRING);
    const [chooseLibraryKey, setChooseLibraryKey] = useState<RemedialQuestionState>(InitialState.EMPTY_STRING);
    const [selectedQuestionCount, setSelectedQuestionCount] = useState<RemedialQuestionState>(InitialState.NUMBER_ZERO);
    const [selectQuestionDialogOpen, setSelectQuestionDialogOpen] = useState<RemedialQuestionState>(InitialState.BOOLEAN_FALSE);
    const [preSelectedFilterContent, setPreSelectedFilterContent] = useState<RemedialQuestionState>(InitialState.EMPTY_OBJECT);
    const [replaceQuestion, setReplaceQuestion] = useState<RemedialQuestionState>(InitialState.BOOLEAN_FALSE);
    const [selectedTempQuestions, setSelectedTempQuestions] = useState<RemedialQuestionState>(InitialState.EMPTY_ARRAY);
    const [selectedTrackedQuestionIds, setSelectedTrackedQuestionIds] = useState<RemedialQuestionState>(InitialState.EMPTY_ARRAY);


    useEffect(() => {
        let isMounted = true;
        if (QuestionId) {
            contentService.getRemedialQuestion(QuestionId).then((res) => {
                const prevRemedialState = remedialQuestionSliceState.remedialState;
                const remedialState = formatRemedialQuestionApi(res.responseObject, remedialKey, prevRemedialState, isRemedialSliceUpdatedMap[remedialKey]);
                if(isRemedialSliceUpdatedMap[remedialKey]){
                    setRemedialSliceUpdated({key: remedialKey, value: false}); 
                }
                if (isMounted && remedialState) {
                    addRemedialQuestionInSliceState(remedialState);
                    const remedialPageState: any = getPropertyValue(remedialState, `${remedialKey}.pageState`, {});;
                    const newExistingQuestion = Object.values(remedialPageState)
                        .map((page: any) => page.question)
                        .filter((question: any) => getPropertyValue(question, 'title'));
                    setExisitingQuestions(newExistingQuestion);
                    const remedialIdsByRemedialKey: any = {};
                    Object.keys(remedialState).forEach((remedialKey) => {
                        const pageState = remedialState[remedialKey].pageState;
                        const remedialIds = Object.values(pageState)
                            .map((page: any) => page.question.content_Id)
                            .filter(Boolean);
                        if (remedialIds.length) {
                            remedialIdsByRemedialKey[remedialKey] = remedialIds;
                        }
                    });
                    if (Object.keys(remedialIdsByRemedialKey).length) {
                        addRemedialQuestionIdsInQuestionCreateSliceState(remedialIdsByRemedialKey);
                    }
                }
            });
        }
        return () => {
            isMounted = false;
        };
    }, [QuestionId, remedialKey]);

    useEffect(() => {
        if (addCommonRemedialQuestion) {
          handleChooseFromLibrary(PROPS_REMEDIAL_KEY.DEFAULT);
        }
    }, [addCommonRemedialQuestion]);

    const remedialState = remedialQuestionSliceState.remedialState;
    if ([remedialState, remedialState && Object.keys(remedialState).length, getPropertyValue(remedialState, `${remedialKey}.pageState`) && Object.keys(remedialState[remedialKey].pageState).length].some(check => !check)) {
        return null;
    }
    const currentRemedialState = remedialState[remedialKey];
    const pageState = currentRemedialState.pageState;

    const handleCloseDialog = () => {
        setDeletePopUpDialog(false);
    };

    const handleCloseDialogForPage = () => {
        setDeletePopUpDialogForPage(false);
    };

    const handleAddPage = (): void => {
        const remedialPageState = remedialState[remedialKey] ? remedialState[remedialKey].pageState : {};
        const pageLength = Object.keys(remedialPageState).length;
        const updatedRemedialState = {
            ...remedialState,
            [remedialKey]: {
                ...(remedialState[remedialKey] || {}),
                pageState: {
                    ...remedialPageState,
                    [`page${pageLength + 1}`]: {
                        question: {
                            ...(remedialPageState[`page${pageLength}`] ? remedialPageState[`page${pageLength}`].question : {}),
                            ...initialQuestionState
                        },
                    }
                }
            }
        };
        addRemedialQuestionInSliceState(updatedRemedialState);
    };

    const removeSelectedQuestion = (searchId: any) => {
        const newFilteredSelectedQuestion = existingQuestions.reduce((acc: any, ele: any) => {
            if (ele.searchId !== searchId && ele.contentId !== searchId) {
                acc.push(ele);
            }
            return acc;
        }, []);
        setExisitingQuestions(newFilteredSelectedQuestion);
    }

    const handleStopDefualtPropagation = (event: any) => {
        event.stopPropagation();
    }

    const handleDeleteQuestions = (deleteId: any) => {
        const remedialPageState = getPropertyValue(remedialState, `${remedialKey}.pageState`, {});
        const searchId = getPropertyValue(pageState, `${deleteId}.question.searchId`);
        if (searchId) {
            removeSelectedQuestion(searchId);
        }
        const updatedRemedialState = {
            ...remedialState,
            [remedialKey]: {
                ...remedialState[remedialKey],
                pageState: {
                    ...remedialState[remedialKey].pageState,
                    [deleteId]: {
                        question: {
                            ...initialQuestionState,
                        }
                    }
                }
            }
        };
        addRemedialQuestionInSliceState(updatedRemedialState);

        const questionId = getPropertyValue(remedialPageState, `${deleteId}.question.content_Id`, null);
        if (questionId &&
            remedialQuestionIds[remedialKey] &&
            remedialQuestionIds[remedialKey].includes(questionId)) {
            const newRemedialIdState = {
                ...remedialQuestionIds,
                [remedialKey]: remedialQuestionIds[remedialKey].filter((id: string) => id !== questionId)
            };
            addRemedialQuestionIdsInQuestionCreateSliceState(newRemedialIdState);
        }
    };

    const handleDeletePageWithPopUp = (pageKey: any) => {
        handleCloseDialog();
        handleDeleteQuestions(pageKey);
    };

    const handleDeletePage = (key: any): void => {
        const remedialPageState = remedialState[remedialKey] ? remedialState[remedialKey].pageState : {};
        const pageKeys = Object.keys(remedialPageState);
        pageKeys.pop();
        const pageKeysLength = pageKeys.length;
        if (key === chooseLibraryKey) {
            const chooseLibraryKeyIndex = pageKeys.indexOf(chooseLibraryKey);
            let newKey = '';
            if (chooseLibraryKeyIndex === pageKeysLength - 1) {
                newKey = pageKeys[chooseLibraryKeyIndex - 1];
            }
            setChooseLibraryKey(newKey);
        }
        const tempPageStateArray = { ...(remedialPageState || {}) };
        delete tempPageStateArray[key];
        let newPageState: any = {};
        Object.values(tempPageStateArray).forEach((pageStateValue, index) => {
            newPageState = { ...newPageState, [`page${index + 1}`]: pageStateValue };
        });

        if (remedialPageState[key] && remedialPageState[key].question && remedialPageState[key].question.searchId) {
            removeSelectedQuestion(remedialPageState[key].question.searchId);
        }

        const questionId = remedialPageState[key] && remedialPageState[key].question && remedialPageState[key].question.content_Id;
        if (questionId && remedialQuestionIds[remedialKey] && remedialQuestionIds[remedialKey].includes(questionId)) {
            const newRemedialIdState = remedialQuestionIds[remedialKey].filter((id: string) => id !== questionId);
            const updatedRemedialQuestionIds = {
                ...remedialQuestionIds,
                [remedialKey]: newRemedialIdState
            };
            addRemedialQuestionIdsInQuestionCreateSliceState(updatedRemedialQuestionIds);
        }

        const updatedRemedialState = {
            ...remedialState,
            [remedialKey]: {
                ...remedialState[remedialKey],
                pageState: {
                    ...newPageState
                }
            }
        };
        addRemedialQuestionInSliceState(updatedRemedialState);
    };

    const handleDeletePageWithPopUpPage = (pageKey: any) => {
        handleCloseDialogForPage();
        handleDeletePage(pageKey);
    }

    const handleFilterSelectedQuestion = (selectedTempQuestions: any) => {
        if (!selectedTempQuestions) return;
        selectedTempQuestions = selectedTempQuestions.length ? selectedTempQuestions : [selectedTempQuestions];
        setExisitingQuestions((prevQuestions: any) => {
            return [...prevQuestions, ...selectedTempQuestions]
        }
        );
    }

    const updateRemedialQuestionIds = (remedialQuestionIds: any, remedialKey: string, id: string) => {
        return {
            ...remedialQuestionIds,
            [remedialKey]: [...(remedialQuestionIds[remedialKey] || []), id],
        };
    };

    const suggestionSelection = (selectedSuggestion: ContentData, pageKey: string) => {
        const type = REMEDIAL_PAGE_KEY.QUESTION;
        const contentSubTypeCode = (selectedSuggestion && +selectedSuggestion.contentSubTypeCode) || REMEDIAL_PAGE_KEY.VIDEO;
        const questionTypeAllowed = isQuestionTypeAllowed(contentSubTypeCode);

        if (questionTypeAllowed) {
            if (selectedSuggestion.status === CONTENT_STATES.PUBLISHED) {
                handleFilterSelectedQuestion(selectedSuggestion);
                const currentRemedialState = remedialState[remedialKey] || { pageState: {} };
                const currentPageState = currentRemedialState.pageState[pageKey] || {};
                const updatedRemedialState = {
                    ...remedialState,
                    [remedialKey]: {
                        ...currentRemedialState,
                        pageState: {
                            ...currentRemedialState.pageState,
                            [pageKey]: {
                                ...currentPageState,
                                [type]: {
                                    ...currentPageState[type],
                                    searchId: selectedSuggestion.contentId,
                                    title: selectedSuggestion.title,
                                    content_Id: selectedSuggestion.content_Id,
                                    passageId: selectedSuggestion.passageId
                                },
                                pageContentType: PAGE_CONTENT_TYPE.QUESTION,
                            }
                        }
                    }
                };
                const updatedRemedialQuestionIds = updateRemedialQuestionIds(remedialQuestionIds, remedialKey, selectedSuggestion.content_Id)
                addRemedialQuestionInSliceState(updatedRemedialState);
                addRemedialQuestionIdsInQuestionCreateSliceState(updatedRemedialQuestionIds);
            } else {
                showMsg(
                    ERROR_MESSAGE_CONTENT_ID,
                    ERROR
                );
            }
        } else {
            if (!questionTypeAllowed) {
                showMsg(
                    ERROR_MESSAGE_CONTENT_ID,
                    ERROR
                );
            }
        }
    }

    const getSearchResults = (searchText: string) => {
        if (!searchText) {
            setSuggestedQuestions(InitialState.EMPTY_ARRAY);
            return;
        }
        const filterContent: any = {
            contentFilterData: [
                {
                    filterValue: FilterValues.contentType,
                    isSelected: true,
                    disabled: false,
                    filters: [{
                        filterValue: FilterValues.question,
                        isSelected: true,
                        disabled: false,
                        filters:
                            []
                    }
                    ]
                },
                {
                    filterValue: FilterValues.status,
                    isSelected: true,
                    filters: [
                        {
                            filterValue: FilterValues.published,
                            isSelected: true,
                            filters: [],
                        },
                    ],
                },
            ],
        };
        const getFilterQuestionContentIdSet = new Set(existingQuestions.map(
            (ele: any) => (ele.searchId ? ele.searchId : ele.contentId)
        ));
        contentService
            .list({ searchText: searchText.toUpperCase(), ...filterContent }, CONTENT_LIST_LIMIT.MIN, CONTENT_LIST_LIMIT.MAX)
            .then((list: ContentData[]) => {
                list = list || [];
                const suggestions = list.filter(suggestion => !getFilterQuestionContentIdSet.has(suggestion.contentId));
                setSuggestedQuestions(suggestions);
            });
    };

    const handleChooseFromLibrary = (pageKeyName: any) => {
        setChooseLibraryKey(pageKeyName);
        setSelectedQuestionCount(InitialState.NUMBER_ZERO);

        let preSelectedFilterContent = {
            contentMenu: FilterValues.ALL,
            goalsDriller: {},
            contentFilterData: [{
                filterValue: FilterValues.contentType,
                isSelected: true,
                disabled: false,
                filters: [{
                    filterValue: FilterValues.question,
                    isSelected: true,
                    disabled: false,
                    filters:
                        []
                }
                ]
            },
            {
                filterValue: FilterValues.status,
                isSelected: true,
                filters: [{
                    filterValue: FilterValues.published,
                    isSelected: true,
                    filters: []
                }],
            }
            ]
        }
        if (replaceQuestion) {
            setReplaceQuestion(InitialState.BOOLEAN_FALSE);
        }
        setSelectQuestionDialogOpen(true);
        setPreSelectedFilterContent(preSelectedFilterContent);
    }

    const handleReplaceQuestion = (keyName: any) => {
        setReplaceQuestion(true);
        handleChooseFromLibrary(keyName);
    }

    const handleBackToQuestionClick = (evt: any) => {
        setSelectQuestionDialogOpen(InitialState.BOOLEAN_FALSE);
        clearContentListData();
        handleAddCommonRemedialQuestion && handleAddCommonRemedialQuestion(false);
    }

    const renderRemedialInfoDesc = () => {
        return (
            <Grid>
                <Grid container direction="row" justify="center" alignItems="center">
                    <Grid>
                        <Typography className={classes.headingTxt}>
                            Practicing Remedial Questions helps a student becoming more proficient in a particular concept or chapter                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
        );
    }

    const renderRemedialQuestionInnrerContainer = (pageKey: string) => {
        const pageNo = getPageNumber(pageKey);
        return (
            (
                <div className={classes.tabsContainer2}>
                    <div className={classes.questionSearchContainer}>
                        <b className={classes.addQuestionTitle}>{`Q.${pageNo}`}</b>
                        <div className={classes.searchContainer}>
                            <MyPATMultiSearch
                                options={suggestedQuestions}
                                labelKey="contentId"
                                valueKey="_id"
                                onChange={(contentData: ContentData) => suggestionSelection(contentData, pageKey)}
                                values=""
                                isSearchAble
                                isCustomFilter
                                filtredFunction={getSearchResults}
                                name={SEARCH}
                                placeholderText={SEARHC_QUESTION_ID}
                            />
                        </div>

                    </div>
                    <Typography variant="caption" className={classes.OrDivider}>
                        <span className={classes.dividerBar}>
                            <b className={classes.orText}> {OR} </b>
                        </span>
                    </Typography>
                    <div className={classes.textAlignCenter}>
                        <Button
                            variant="contained"
                            color="primary"
                            className={classes.mb1x}
                            onClick={() => handleChooseFromLibrary(pageKey)}
                            target="_blank"
                        >
                            {CHOOSE_FROM_LIBRARY}
                        </Button>
                    </div>
                </div>
            )
        )
    }

    const handleCrossIconPage = (pageNameKey: string) => {
        setDeletePopUpDialogForPage(true);
        setDeleteKeyForPage(pageNameKey);
    }

    const renderPageCrossIconComponent = (pageNameKey: string) => {
        if (pageNameKey === PageKeys.Page1) {
            return null;
        }
        return (
            <div className={classes.dFlex}>
                <IconButton
                    className={cx(classes.tabsNotes, classes.myButtonStyle)}
                    onClick={() => handleCrossIconPage(pageNameKey)}
                >
                    <img alt="Cancel video upload" src="/assets/svg/learn/closePanel.svg" className={classes.pointerCursor} />
                </IconButton>
                <DeletePopUp
                    openDialog={deletePopUpDialogForPage}
                    handleClose={handleCloseDialogForPage}
                    deleteFunction={() => handleDeletePageWithPopUpPage(deleteKeyForPage)}
                />
            </div>
        )
    }

    const renderAddQuestion = (pageKey: string, hideAddComponet: boolean) => {
        const addQuestionClass = !hideAddComponet ? classes.addQuestionContainer : cx(classes.addQuestionContainer, classes.flexEnd)
        return (
            <div className={addQuestionClass}>
                {!hideAddComponet && (<Typography variant="h6">
                    {`${ADD_QUESTION}`}
                </Typography>)}
                {renderPageCrossIconComponent(pageKey)}
            </div>
        )
    }

    const renderRemedialQuestionListComponent = () => {
        return Object.keys(pageState).map((key, index) => {
            const pageName = `Question ${index + 1}`;
            const pageKey = `page${index + 1}`;
            const showAddQuestionComponent = !(
                getPropertyValue(pageState, `${pageKey}.question.title`) ||
                getPropertyValue(pageState, `${pageKey}.question.customDescription`) ||
                getPropertyValue(pageState, `${pageKey}.question.content_Id`)
            );
            return (
                <>
                    <div key={pageKey} className={classes.paddingTop10}>
                        {renderAddQuestion(pageKey, showAddQuestionComponent)}
                        {
                            showAddQuestionComponent
                                ? renderRemedialQuestionInnrerContainer(pageKey)
                                : renderselectedQuestionComponent(pageKey)
                        }
                    </div>
                </>
            );
        });
    }

    const handleOpenDeleteDialog = (deleteKey: string) => {
        setDeletePopUpDialog(true);
        setDeleteKeyForPage(deleteKey);
    }

    const renderselectedQuestionComponent = (pageKeyName: any) => {
        return (
            <RemedialSelectedIndivualComponent
                pageKeyName={pageKeyName}
                pageState={pageState}
                deletePopUpDialog={deletePopUpDialog}
                handleOpenDeleteDialog={handleOpenDeleteDialog}
                handleReplaceQuestion={handleReplaceQuestion}
                handleCloseDialog={handleCloseDialog}
                handleDeletePageWithPopUp={handleDeletePageWithPopUp}
                deleteKeyForPage={deleteKeyForPage}
                classes={classes}
            />
        );
    };

    const renderAddQuestionCta = () => {
        const pageLength = (Object.keys(pageState) || []).length
        return (
            <div className={classes.addButtonAlign}>
                <Button
                    variant="contained"
                    color="primary"
                    className={classes.addPageMore}
                    onClick={() => handleAddPage()}
                    disabled={pageLength >= QUESTION_LIMIT.MAX_LIMIT}
                >
                    + Add Question
                </Button>
            </div>
        )
    }

    const getQuestionLimit = () => {
        return replaceQuestion ? QUESTION_LIMIT.REPLACE_QUESTION : addCommonRemedialQuestion ? QUESTION_LIMIT.MAX_LIMIT : Math.max(QUESTION_LIMIT.MAX_LIMIT - existingQuestions.length, 0);
    }

    const filterDuplicatePassage = (contentList: any[]): any[] => {
        const passageSet = new Set<string>();
        contentList = contentList.filter((passage: any) => {
            const { passageId = '' } = passage;
            if (passageId && !passageSet.has(passageId)) {
                passageSet.add(passageId);
                return true;
            }
            return !passageId;
        });
        return contentList;
    }

    const handleOnContentSelect = (selectedQuestions: any[]) => {
        selectedQuestions = filterDuplicatePassage(selectedQuestions);
        const selectedTempQuestions: any[] = [];
        setSelectedQuestionCount(InitialState.NUMBER_ZERO);
        setSelectedTempQuestions(InitialState.EMPTY_ARRAY);
        selectedQuestions.forEach((question: any) => {
            if (question.passageData && question.passageData.length > 1) {
                question.title = question.passageData[0].title;
                question.contentId = question.passageData[0].contentId;
                question.content_Id = question.passageData[0].id;
            }
            const contentSubTypeCode = (question && +question.contentSubTypeCode);
            const questionTypeAllowed = question && isQuestionTypeAllowed(contentSubTypeCode);
            if (questionTypeAllowed) {
                selectedTempQuestions.push(question);
            }
        });
        setSelectedQuestionCount(selectedTempQuestions.length);
        setSelectedTempQuestions(selectedTempQuestions);
    }

    const handleContentSelectAll = (selectedQuestions: any) => {
        handleOnContentSelect(selectedQuestions)
    }

    const handleAddContentClick = () => {
        let newPageState = addCommonRemedialQuestion ? { ...DEFAULT_PAGE_STATE } : { ...pageState };
        const selectedQuestionLength = selectedTempQuestions.length ? selectedTempQuestions.length - 1 : 0;
        const currentPage = getNumberFromString(chooseLibraryKey);
        const pages = Object.keys(newPageState);

        pages.forEach(page => {
            const pageNumber = getNumberFromString(page);
            if (currentPage >= pageNumber) return;

            const newPageNumber = pageNumber + selectedQuestionLength;
            newPageState[`page${newPageNumber}`] = pageState[page];
        });

        selectedTempQuestions.forEach((question: any, index: number) => {
            const newPageNumber = currentPage + index;
            newPageState[`page${newPageNumber}`] = {
                question: {
                    searchId: question.contentId,
                    title: question.title,
                    content_Id: question.content_Id,
                    subHeading: '',
                    passageId: question.passageId
                },
                pageContentType: 'Question'
            };
        });
        const newPageStateToAddInSlice = { ...newPageState };
        const defaultRemedialState = {
            ...remedialState,
            [remedialKey]: {
                ...remedialState[remedialKey],
                pageState: {
                    ...remedialState[remedialKey].pageState,
                    ...newPageStateToAddInSlice
                }
            }
        };
        const newRemedialIdsArrayByRemedialKey = Object.values(newPageStateToAddInSlice)
            .map((page: any) => page.question.content_Id)
            .filter(contentId => contentId !== '');
        const defaultModifiedQuestionIds = {
            ...remedialQuestionIds,
            [remedialKey]: newRemedialIdsArrayByRemedialKey
        };
        let modifiedRemedialQuestionIds = {};
        let updatedRemedialState: any = {};
        const totalRemedialState = remedialQuestionSliceState.noOfRemedialPage;
        if (addCommonRemedialQuestion) {
            if (totalRemedialState && totalRemedialState !== -1) {
                for (let index = 0; index < totalRemedialState; index++) {
                    const newRemedialKey = `${REMEDIAL_KEY.REMEDIAL}${index + 1}`;
                    updatedRemedialState = {
                        ...updatedRemedialState,
                        [newRemedialKey]: {
                            pageState: {
                                ...newPageStateToAddInSlice
                            }
                        }
                    }
                    modifiedRemedialQuestionIds = {
                        ...modifiedRemedialQuestionIds,
                        [newRemedialKey]: newRemedialIdsArrayByRemedialKey
                    }
                };
            }
            handleAddCommonRemedialQuestion && handleAddCommonRemedialQuestion(false);
            showMsg(
                ADD_COMMON_QSTN,
                SUCCESS
            );
        } else {
            updatedRemedialState = defaultRemedialState;
            modifiedRemedialQuestionIds = defaultModifiedQuestionIds;
        }
        addRemedialQuestionIdsInQuestionCreateSliceState(modifiedRemedialQuestionIds);
        addRemedialQuestionInSliceState(updatedRemedialState);
        const newExistingQuestion = Object.values(newPageStateToAddInSlice)
            .map((page: any) => page.question)
            .filter(question => !!question);
        setExisitingQuestions(newExistingQuestion);
        setSelectQuestionDialogOpen(InitialState.BOOLEAN_FALSE);
        setSelectedTempQuestions(InitialState.EMPTY_ARRAY);
        clearContentListData();
    };

    const renderWithContentComponent = () => {
        const otherDialogProps = {
            fullScreen: true,
        };
        const questionLimit = getQuestionLimit();
        return (
            <Dialog
                {...otherDialogProps}
                open={selectQuestionDialogOpen}>
                <div className={classes.widthAuto}>
                    <DialogTitle classes={{ root: classes.dialogTitle }}>
                        <>
                            <Grid container justify="space-between" alignItems="center">
                                <Grid item xs="auto">
                                    <Typography
                                        color="textPrimary"
                                        variant="body1"
                                        className={classes.pointerCursor}
                                        onClick={handleBackToQuestionClick}
                                    >
                                        <BackIcon classes={{ root: classes.backIconRoot }} />
                                        <strong>Back to Question</strong>
                                    </Typography>
                                </Grid>
                                <Grid item xs />
                                <Grid item xs="auto">
                                    <Typography variant="caption" inline>
                                        <b className={classes.selectedQuestionStyle}>{selectedQuestionCount}/{questionLimit} Selected</b>
                                    </Typography>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={handleAddContentClick}
                                        disabled={selectedQuestionCount > questionLimit || selectedQuestionCount === 0}
                                    >
                                        Add Content
                                    </Button>
                                </Grid>
                            </Grid>
                        </>
                    </DialogTitle>
                    <DialogContent classes={{ root: classes.dialogContent }}>
                        <PerfectScrollbar className={`dialog-content ${classes.perfectScrollbar}`}>
                            <WithContent
                                isInPopUp={true}
                                selectedQuestions={selectedTempQuestions}
                                selectedTrackedQuestionIds={selectedTrackedQuestionIds}
                                filterSelectedQuestion={existingQuestions}
                                onContentSelect={handleOnContentSelect}
                                onContentSelectAll={handleContentSelectAll}
                                onCheckContentExist={() => { }}
                                selectedFilterContent={preSelectedFilterContent}
                                fromTestPaper={true}
                                type={REMEDIAL_PAGE_KEY.QUESTION}
                                removeDisabilityFromCheckBox={true}
                                isSelectAllRequired={false}
                                contentCreateOption={false}
                                fromNotes={true}
                                bucketsToDisplay={[CONTENT_SECTION_TYPES[0]]}
                                preSelectedBucket={CONTENT_SECTION_KEYS.GLORIFIRE}
                            />
                        </PerfectScrollbar>
                    </DialogContent>
                </div>
            </Dialog>
        )
    }

    return (
        <MyPATExpansionPanel
            defaultExpanded={defaultExpanded}
            variant="white"
            hasExpandIcon
            customCollapseTitle={
                <Grid container justify="space-between">
                    <Grid item>
                        <Typography
                            id='remedialQuestion'
                            onClick={handleStopDefualtPropagation}
                            variant="h6"
                            className={(classes.cardHeading, classes.headingRelative)}>
                            {`${REMEDIAL_QUESTION}`}
                            <span className={classes.optionalText}> (Optional) </span>
                            <CustomInfoIcon
                                isInfoIcon={true}
                                isRightArrow={false}
                                isCenterArrow={true}
                                knowMoreAbout={false}
                                dialogTitle={REMEDIAL_QUESTION}
                                imageURL="\assets\svg\myLibrary\remedialInfo.svg"
                                dialogPara=""
                                details="Click to know more"
                                toolTipDirection="top"
                                showMore="false"
                                htmlElement={renderRemedialInfoDesc()}
                            />
                        </Typography>
                    </Grid>
                </Grid>
            }
        >
            {renderRemedialQuestionListComponent()}
            {renderAddQuestionCta()}
            {renderWithContentComponent()}
        </MyPATExpansionPanel>
    )
}

const mapStateToProps = (state: any) => {
    return {
        remedialQuestionSliceState: state.remedialQuestionReducer,
        remedialQuestionIds: state.questionCreate.remedialQuestionIds,
        isRemedialSliceUpdatedMap: state.remedialQuestionReducer.isRemedialSliceUpdatedMap,
    };
};

const mapDispatchToProps = (dispatch: any) =>
    bindActionCreators(
        {
            showMsg: showMsg,
            addRemedialQuestionInSliceState: remedialQuestionActions.addRemedialQuestion,
            clearContentListData: contentActions.clearContentListData,
            addRemedialQuestionIdsInQuestionCreateSliceState: questionActions.setRemedialQuestionIds,
            setRemedialSliceUpdated: remedialQuestionActions.setRemedialSliceUpdated,
        },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
    // @ts-ignore
)(withStyles(styles)(React.memo(RemedialQuestion)));
